export function getErrorToastMessage(err, t) {
  const backendMessage = err?.response?.data?.message;
  if (backendMessage) return backendMessage;

  const status = err?.response?.status;

  if (status === 401 || status === 403) return t('MODAL.NO_PERMISSION');

  return t('MODAL.ERROR');
}